/* eslint-disable func-style */
/* eslint-disable valid-jsdoc */
import axios from './index';
import { getUserToken } from './query-params';
import { showLoginBox } from './postmessage'
import OSS from 'ali-oss';
/**
 *  项目分享
 * @param {string}  exerciseId 项目(习题)Id
 * @param {string}  exerciseName 项目名称
 * @param {string}  description 项目描述
 * @param {string}  cityCode 城市编码
 * @param {number}  category 项目类型
 * @param {number}  role 角色
 * @returns {Object} data 返回数据
 */
export function shareProj (params) {
    return axios.post(`${API_BASE_URL}/core/share/content/exercise`, params);
}

/**
 * 获取分享视频积分
 * @param {string} token 凭证
 */
export function videoPointUpLimit () {
    return axios.get(`${API_BASE_URL}/core/videoShare/videoPointUpLimit`);
}

/**
 * 发布到公开社区
 * @param {object} params
 * @param {array} params.tags
 * @param {string} params.classId
 * @param {string} params.lessonId
 * @param {object} params.scratchDto
 * @param {number} params.scratchDto.category
 * @param {string} params.scratchDto.description
 * @param {string} params.scratchDto.name
 * @param {string} params.scratchDto.thumbnailPath
 * @param {string} params.scratchDto.version
 * @param {string} params.scratchDto.xml
 */
export function communityPublish (params) {
    return axios.post(`${API_BASE_URL}/community/works/publish/common`, params);
}

/**
 * 获取学生在读的所有开课中、7天内即将开课、已结课7天内的班级Ids
 * @param {object} params 需要传递的参数
 * @param {string} token 凭证
 */
export function getClassIds(params, token) {
    return axios.post(`${API_BASE_URL}/community/works/share/classIds/get`, params);
}

/**
 *  视频分享成功回调
 *  @param {string} videoId 视频id
 */
export function videoConfirm (params) {
    const videoId = params.videoId;
    return axios.post(`${API_BASE_URL}/core/video/confirm/${videoId}`);
}

/**
 * 视频分享
 * @param {string} videoId 视频id
 */
export function shareVideoPro (params) {
    return axios.post(`${API_BASE_URL}/core/videoShare/save`, params);
}

/**
 * 分享链接长链变短链
 * @param {object} url 需要传递的url
 */
export function getShortShareUrl(params) {
    const { url } = params;
    return axios.get(`${API_BASE_URL}/core/public/share/shortUrl?url=${url}`);
}

/**
 *
 * @param {object} params param
 * @returns Promise
 */
export function updateExerciseStatus (params) {
    return axios.post(`${API_BASE_URL}/core/practice-result/respond`, params);
}

export const SCRATCH_OSS_MODULE_ASSETS = 'scratch/assets';
export const SCRATCH_OSS_MODULE_THUMBNAIL = 'scratch/thumbnail';
const CDN_BASE = 'https://static.xiaohoucode.com';

function getStsDirPrefix (sign) {
    const raw = String((sign && sign.dir) || '').replace(/^\//, '');
    if (!raw) return '';
    if (/\.[a-z0-9]+$/i.test(raw) && !raw.endsWith('/')) {
        const index = raw.lastIndexOf('/');
        return index >= 0 ? raw.slice(0, index) : '';
    }
    return raw.replace(/\/$/, '');
}

export function toCdnUrl (key) {
    const raw = String(key || '').replace(/^\//, '');
    return raw ? `${CDN_BASE}/${raw}` : CDN_BASE;
}

export function getOssSign (params) {
    if (!getUserToken()) {
        showLoginBox()
    }
    const list = (params && params.params) || [];
    const type = list[0] && list[0].type;
    const moduleName = Number(type) === 1 ? SCRATCH_OSS_MODULE_THUMBNAIL : SCRATCH_OSS_MODULE_ASSETS;
    return axios.get(`${API_BASE_URL}/core/oss/common/sign/user`, {
        params: {module: moduleName}
    }).then(res => {
        const sign = res.data && res.data.data;
        if (!sign || !sign.accessKeyId) {
            return Promise.reject(new Error('获取 OSS 凭证失败'));
        }
        const data = (list.length ? list : [{fileName: sign.fileName}]).map(item => ({
            sign: Object.assign({}, sign, {
                fileName: item.fileName || sign.fileName
            }),
            savePath: item.fileName || sign.fileName
        }));
        return Object.assign({}, res, {
            data: Object.assign({}, res.data, {data})
        });
    });
}


/**
 *  资源上传oss
 */
export function upload (file, signData) {
    if (signData && signData.accessKeyId && signData.securityToken) {
        const prefix = getStsDirPrefix(signData);
        const leaf = signData.fileName || (file && file.name) || `file_${Date.now()}`;
        const key = prefix ? `${prefix}/${leaf}` : leaf;
        const client = new OSS({
            region: 'oss-cn-zhangjiakou',
            bucket: 'codingcloud',
            accessKeyId: signData.accessKeyId,
            accessKeySecret: signData.accessKeySecret,
            stsToken: signData.securityToken,
            secure: true
        });
        return client.put(key, file).then(result => {
            signData.dir = key;
            signData.fileName = leaf;
            return {
                key,
                message: result && result.res && result.res.status,
                url: toCdnUrl(key)
            };
        });
    }
    return new Promise((resolve, reject) => {
        // const key = `${signData.dir}/${signData.fileName}`;
        const key = signData.dir;
        const request = new FormData();
        request.append('name', signData.fileName);
        request.append('OSSAccessKeyId', signData.accessId);
        request.append('policy', signData.policy);
        request.append('signature', signData.signature);
        request.append('key', key);
        request.append('success_action_status', '200');
        request.append('file', file);
  
        const uxhr = new XMLHttpRequest();
        uxhr.onreadystatechange = () => {
            if (uxhr.readyState === 4) {
                if (
                    (uxhr.status >= 200 && uxhr.status < 300) || uxhr.status === 304
                ) {
                    resolve({
                        key,
                        message: uxhr.responseText,
                        url: `${signData.host}/${key}`
                    });
                } else {
                    reject(uxhr.status);
                }
            }
        };
  
        uxhr.open('post', 'https://codingcloud.oss-cn-zhangjiakou.aliyuncs.com', true);
        uxhr.send(request);
    });
}

/**
 * 文本内容审核检查接口
 * @param {object} params 参数
 * @param {string} params.url 检查内容
 * @param {number} params.module 模块
 * @param {object} cancelToken axios CancelToken，用于取消请求
 * @returns {Object} data 返回数据
 */
export function textCheck(params, cancelToken) {
    const config = cancelToken ? { cancelToken } : {};
    return axios.post(`${API_BASE_URL}/core/safeCheck/guardian/check/text`, params, config);
}

/**
 * 视频内容审核检查接口
 * @param {object} params 参数
 * @param {number} params.type 类型（3：视频）
 * @param {string} params.url 资源路径
 * @param {string} params.md5 视频内容MD5
 * @param {number} params.module 模块（3:分享视频上传）
 * @param {string} params.authorId 作者id
 * @param {string} params.authorName 作者姓名
 * @param {number} params.role 角色（1:教师,2:学生,3:管理员）
 * @param {string} params.businessId 业务id
 * @param {object} cancelToken axios CancelToken，用于取消请求
 * @returns {Object} data 返回数据
 */
export function videoCheck(params, cancelToken) {
    const config = cancelToken ? { cancelToken } : {};
    return axios.post(`${API_BASE_URL}/core/safeCheck/guardian/check`, params, config);
}